import { me } from "../../api/maul-client/errors"

// ─── Parsing ───

/**
 * Parses the `data` field from a React Router route error response
 * into a typed error body. Returns `null` if the data doesn't match
 * the expected shape (e.g., thrown by non-send code paths).
 */
export function parseRouteErrorBody(
  serializedMaybeCombinedError: unknown,
): me.TCombinedInferred | null {
  try {
    if (typeof serializedMaybeCombinedError !== "string") {
      return null
    }

    const maybeCombinedError = me.deserialize(serializedMaybeCombinedError)
    const { success, data: combinedError } = me.combinedSchema.safeParse(maybeCombinedError)
    if (!success) return null

    return combinedError
  } catch {
    return null
  }
}
